export const baseData = {
  title: "DEPARTEMENT"
}